import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusValue } from '../data/copy';
import { BONUS_SIZES, BONUS_WIDTHS, optimizedImage, optimizedSrcSet } from '../utils/image';
export function BonusesSection() {
  return <section id="bonos" className="defer-paint w-full scroll-mt-6 bg-surface py-12 sm:py-14" aria-labelledby="bonuses-heading" data-id="element-14" data-mp="qtt5gktb0l77">
      <div className="mx-auto max-w-5xl px-6" data-id="element-15" data-mp="14s9lj2d23o20">
        <SectionHeading eyebrow="Inclusi gratis" title={<span id="bonuses-heading" data-id="element-17" data-mp="zu7thrxnkeee">+ 5 bonus strategici</span>} lead={`Valore ${bonusValue}, inclusi oggi senza costi aggiuntivi.`} data-id="element-16" data-mp="zuhjhfip6lk3" />

        <ul className="mt-9 grid grid-cols-2 gap-3 sm:gap-4" data-id="element-18" data-mp="19jrfh6gnwodh">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col gap-3 rounded-2xl border border-line bg-card p-3.5 sm:flex-row sm:items-center sm:gap-5 sm:p-5" data-id="element-19" data-mp="1njk8j8fnvgom">
              <img src={optimizedImage(bonus.image, 192)} srcSet={optimizedSrcSet(bonus.image, BONUS_WIDTHS)} sizes={BONUS_SIZES} alt={bonus.alt} className="h-auto w-16 shrink-0 self-start rounded-lg object-cover sm:w-24 sm:self-center sm:rounded-xl" width={192} height={192} loading="lazy" decoding="async" {...{
            fetchpriority: 'low'
          }} data-id="element-20" data-mp="3pr3p4nm14wrx" />

              <div className="min-w-0 flex-1" data-id="element-21" data-mp="gk2l1ifsrdes">
                <div className="flex items-center gap-2.5" data-id="element-22" data-mp="lc3u6vho4o0l">
                  <p className="font-sans text-[10px] font-semibold uppercase tracking-[0.2em] text-muted" data-id="element-23" data-mp="lcne2hqvpmh9">
                    Bonus {bonus.number}
                  </p>
                  <span className="shrink-0 rounded-full bg-accent px-2 py-0.5 font-sans text-[9px] font-bold uppercase tracking-[0.14em] text-white" data-id="element-24" data-mp="vb2tvokgh9bg">
                    Gratis
                  </span>
                </div>

                <h3 className="mt-2 font-serif text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-25" data-mp="alqrujhltjxu">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 font-sans text-[0.8rem] leading-relaxed text-muted" data-id="element-26" data-mp="kas90czvy7de">
                  {bonus.tagline}
                </p>
                <p className="mt-2 font-sans text-[11px] text-muted" data-id="element-27" data-mp="fiqz2xq6wsqj">
                  Valore: <span className="line-through" data-id="element-28" data-mp="tap0snhknmco">{bonus.value}</span>
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}